/**
 * Theme data - storage the information of the theme
 */

import defaultConfig from "./default-store.config";
import { BlogDetailCustomizes } from "./pages/blog/blog-detail/blog-detail.customize";
import BlogDetailPage from "./pages/blog/blog-detail/blog-detail.page";
import { BlogListCustomizes } from "./pages/blog/blog-list/blog-list.customize";
import BlogListPage from "./pages/blog/blog-list/blog-list.page";
import { CheckoutCustomizes } from "./pages/checkout/checkout.customize";
import Theme1Checkout from "./pages/checkout/checkout.page";
import { HomeCustomizes } from "./pages/home/home.customize";
import { LoginCustomizes } from "./pages/login/login.customize";
import { MyProfileCustomizes } from "./pages/my-profile/my-profile.customize";
import { ProductDetailCustomizes } from "./pages/product-detail/product-detail.customize";
import ProductDetailPage from "./pages/product-detail/product-detail.page";
import { ProductListCustomize } from "./pages/product-list-new/components/product-list-page.customize";

const { default: PageType } = require("./constants/page-type.constants");
const { default: HomePage } = require("./pages/home/home.page");
const { default: LoginPage } = require("./pages/login/login.page");
const { default: MyProfilePage } = require("./pages/my-profile/my-profile.page");
const { default: ProductListPage } = require("./pages/product-list-new/product-list.page");

const themeData = {
  id: "921016fe-d34e-4192-beb8-15d775d0ee5b", // the static id generated by GoF&B system
  name: "TropicalFruit", // theme name
  pages: [
    // the all pages of theme
    {
      id: PageType.HOME_PAGE, // page id - static data get from system
      name: "Homepage", // name of page
      component: HomePage, // main page
      customizes: HomeCustomizes, // customize objects
      path: "/home", // path to access to page from browser
      metaInfo: {
        title: "Trang chủ",
        description: "Trang chủ",
      },
    },
    {
      id: PageType.PRODUCT_LIST,
      name: "Product list",
      component: ProductListPage,
      customizes: ProductListCustomize, // customize objects
      path: "/product-list",
      metaInfo: {
        title: "Danh sách sản phẩm",
        description: "Tất cả sản phẩm",
      },
    },
    {
      id: PageType.PRODUCT_LIST,
      name: "Product list",
      component: ProductListPage,
      customizes: ProductListCustomize, // customize objects
      path: "/product-list/:productCategoryId",
      metaInfo: {
        title: "Danh sách sản phẩm",
        description: "Tất cả sản phẩm",
      },
    },
    {
      id: PageType.PRODUCT_DETAIL,
      name: "Product detail",
      component: ProductDetailPage,
      customizes: ProductDetailCustomizes,
      path: "/product-detail/:productId",
      metaInfo: {
        title: "Chi tiết sản phẩm",
        description: "Chi tiết sản phẩm",
      },
    },
    {
      // IMPORTANT -- Currently there is no customization for COMBO_DETAIL, so switch to PRODUCT_DETAIL's config
      id: PageType.PRODUCT_DETAIL,
      name: "Combo detail",
      component: ProductDetailPage,
      customizes: [],
      path: "/combo-detail/:comboType/:comboId",
      metaInfo: {
        title: "Chi tiết sản phẩm",
        description: "Chi tiết sản phẩm",
      },
    },
    {
      id: PageType.BOOKING,
      name: "Booking",
      component: HomePage,
      customizes: [],
      path: "/booking",
      metaInfo: {
        title: "Đặt lịch",
        description: "Đặt lịch",
      },
    },
    {
      id: PageType.CART_PAGE,
      name: "Cart page",
      component: HomePage,
      customizes: [],
      path: "/cart",
      metaInfo: {
        title: "Đặt hàng",
        description: "Đặt hàng",
      },
    },
    {
      id: PageType.CHECKOUT_PAGE,
      name: "Checkout page",
      component: Theme1Checkout,
      customizes: CheckoutCustomizes,
      path: "/checkout",
      metaInfo: {
        title: "Đơn hàng",
        description: "Đơn hàng",
      },
    },
    {
      id: PageType.REGISTER_PAGE,
      name: "Register page",
      component: HomePage,
      customizes: [],
      path: "/register",
      metaInfo: {
        title: "Đăng ký tài khoản",
        description: "Đăng ký tài khoản",
      },
    },
    {
      id: PageType.LOGIN_PAGE,
      name: "Login page",
      component: LoginPage,
      customizes: LoginCustomizes, // customize objects
      path: "/login",
      metaInfo: {
        title: "Đăng nhập",
        description: "Đăng nhập",
      },
    },
    {
      id: PageType.FORGOT_PASSWORD_PAGE,
      name: "Forgot password page",
      component: HomePage,
      customizes: [],
      path: "/forgot-password",
      metaInfo: {
        title: "Quên mật khẩu",
        description: "Quên mật khẩu",
      },
    },
    {
      id: PageType.MY_PROFILE_PAGE,
      name: "My profile page",
      component: MyProfilePage,
      customizes: MyProfileCustomizes,
      path: "/my-profile",
      metaInfo: {
        title: "Hồ sơ của tôi",
        description: "Hồ sơ của tôi",
      },
    },
    {
      id: PageType.MY_PROFILE_PAGE,
      name: "My profile page",
      component: MyProfilePage,
      customizes: MyProfileCustomizes,
      path: "/my-profile/:index",
      metaInfo: {
        title: "Hồ sơ của tôi",
        description: "Hồ sơ của tôi",
      },
    },
    {
      id: PageType.MY_PROFILE_PAGE,
      name: "My profile page",
      component: MyProfilePage,
      customizes: MyProfileCustomizes,
      path: "/my-profile/:index/:id",
      metaInfo: {
        title: "Hồ sơ của tôi",
        description: "Hồ sơ của tôi",
      },
    },
    {
      id: PageType.CONTACT_PAGE,
      name: "Contact page",
      component: HomePage,
      customizes: [],
      path: "/contact",
      metaInfo: {
        title: "Liên hệ",
        description: "Liên hệ",
      },
    },
    {
      id: PageType.ABOUT_US_PAGE,
      name: "About Us page",
      component: HomePage,
      customizes: [],
      path: "/about-us",
      metaInfo: {
        title: "About Us",
        description: "About Us",
      },
    },
    {
      id: PageType.BLOG_LIST_PAGE,
      name: "Blog",
      component: BlogListPage,
      customizes: BlogListCustomizes,
      path: "/blog",
      metaInfo: {
        title: "Bài viết",
        description: "Bài viết",
      },
    },
    {
      id: PageType.BLOG_DETAIL_PAGE,
      name: "Blog detail",
      component: BlogDetailPage,
      customizes: BlogDetailCustomizes,
      path: "/blog/:path",
      metaInfo: {
        title: "Chi tiết bài viết",
        description: "Chi tiết bài viết",
      },
    },
  ],
};

const themeToken = {
  fontFamily: "Plus Jakarta Sans",
};

const getRouteMetaInfo = (routeId) => {
  const route = themeData.pages.find((r) => r.id === routeId);
  return route?.metaInfo ?? {};
};

const theme = { themeData, defaultConfig, themeToken, getRouteMetaInfo };
export default theme;
